import React from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  Card,
  CardContent,
  CardMedia,
  IconButton
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { useNavigate } from "react-router-dom";

// Assets
import bgPolygon from "../assets/bg_polygon.png";
import logo from "../assets/logo.png";
import directorImg from "../assets/director_img.webp";

export default function Counselling() {

  const navigate = useNavigate();

  return (
    <Box sx={{ width: "100%", bgcolor: "#fafafa" }}>

      {/* ================= HEADER ================= */}

      <Box
        sx={{
          height: { xs: 280, md: 360 },
          backgroundImage: `url(${bgPolygon})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative"
        }}
      >

        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.45)"
          }}
        />

        {/* Top Bar */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            p: 2,
            color: "#fff"
          }}
        >
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
            <ArrowBackIcon />
          </IconButton>

          <Typography fontWeight="bold">
            Shooin Stars
          </Typography>
        </Box>

        {/* Center Logo */}
        <Box
          sx={{
            position: "relative",
            height: "75%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "#fff",
            px: 2
          }}
        >

          <img src={logo} alt="logo" width="90" />

          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ mt: 1 }}
          >
            SHOOIN STARS
          </Typography>

          <Typography fontSize="13px" color="#ddd">
            ENGINEERING ADMISSIONS | FOUNDATION COURSE
          </Typography>

        </Box>

      </Box>

      {/* ================= CONTENT ================= */}

      <Box
        sx={{
          maxWidth: 900,
          mx: "auto",
          px: { xs: 2, md: 4 },
          pb: 6
        }}
      >

        {/* ABOUT US */}

        <SectionTitle text="About Us" />

        <Para>
          Choosing the right engineering college is one of the most important decisions in a student’s life — and it should never be based on confusion, assumptions, or incomplete information.
        </Para>

        <Para>
          We are a student-first MHT-CET counseling platform created to bring clarity, transparency, and strategy into the engineering admission process.
        </Para>

        <Para>
          With 10+ years of real counseling experience, we have admitted 8000+ student and trained 4000+ stuudent all over Maharashtra through CAP, ACAP, NRI, CIWG and Institute Level admissions.
        </Para>

        <DividerBlock />

        {/* WHAT WE BELIEVE */}

        <SectionTitle text="What We Believe" />

        <Bullet text="Admissions must be data-driven, not guesswork" />
        <Bullet text="Students deserve accurate, official and easy-to-understand information" />
        <Bullet text="A well-planned preference form and branch selection can shape a student’s long-term career" />
        <Bullet text="Guidance should focus on the right college and right branch fit" />
        <Bullet text="Non-CAP and institute-level admissions are equally important and often overlooked" />

        <DividerBlock />

        {/* FEATURES */}

        <SectionTitle text="What This App Helps You With" />

        <Bullet text="College Predictor based on previous year cut-off data" />
        <Bullet text="Cut-off Explorer for all MHT-CET engineering colleges" />
        <Bullet text="Detailed College Profiles (fees, intake, placements)" />
        <Bullet text="Preference Form Generator with strategic ordering" />
        <Bullet text="Counseling Timeline & Important Updates" />
        <Bullet text="Document Checklist & Tracking" />
        <Bullet text="Non-CAP & Institute-Level Admission Guidance" />
        <Bullet text="Foundation Course & Live Seminars" />

        <DividerBlock />

        {/* TRUST */}

        <SectionTitle text="Why Parents and Students Trust Us" />

        <Bullet text="UCLA Certified Counseling Expertise" />
        <Bullet text="CAP, ACAP & Institute-Level Admission Specialists" />
        <Bullet text="Experience across Top Colleges & Cities" />

        <DividerBlock />

        {/* DIRECTOR */}

        <SectionTitle text="About The Director" />

        <Card
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0 8px 30px rgba(0,0,0,0.2)"
          }}
        >

          <CardMedia
            component="img"
            image={directorImg}
            sx={{
              height: 380,
              objectFit: "contain",
              backgroundColor: "#000",
              padding: "12px"
            }}
          />

          <CardContent sx={{ bgcolor: "#111", color: "#fff" }}>

            <Typography fontWeight="bold">
              Kalpesh Hiwase
            </Typography>

            <Typography fontSize="13px" color="#bbb">
              Director & Senior Admission Counselor
            </Typography>

            <Typography fontSize="14px" sx={{ mt: 1 }}>
              Kalpesh Hiwase is the Director of this platform and a senior admission counselor with over 10 years of experience in MHT-CET engineering admissions.
He holds a Bachelor’s degree in Engineering (B.E.), an MBA, and is a UCLA-Certified Counselor, bringing together technical knowledge, management perspective, and structured counseling expertise.
Before dedicating himself full-time to admission counseling, he has worked with leading organizations such as Tech Mahindra, Naukri.com, and Allen Career Institute, gaining deep exposure to the education, employment, and career ecosystem.
During his tenure at Naukri.com, he closely interacted with Training & Placement Officers (TPOs) of engineering colleges across Maharashtra. This gave him a unique insight into a recurring problem:
many capable students were landing in the wrong colleges — not due to lack of merit, but due to lack of proper understanding of the admission process and counseling strategy.
This realization became the foundation of his mission.
He went on to establish an organization focused on helping students choose the right college and right branch, using accurate data, correct counseling, and timely guidance — so deserving students could genuinely reach their dream engineering colleges.
He has since personally guided 8,000+ students and parents through CAP, ACAP, and institute-level admissions, helping them make realistic, well-planned, and future-oriented choices.
Known for his transparent, data-backed counseling approach, he emphasizes student merit, branch selection, financial planning, and long-term career outcomes over brand-driven decisions.
This platform is developed under his direct guidance, based on official admission data and proven counseling strategies refined over a decade of hands-on experience.
            </Typography>

          </CardContent>

        </Card>

        {/* WHATSAPP */}

        <Button
  fullWidth
  startIcon={<WhatsAppIcon />}
  href="https://whatsapp.com/channel/0029VbCxJ3r3wtbIi0g7dg0W"
  target="_blank"
  rel="noopener noreferrer"
  sx={{
    mt: 4,
    bgcolor: "#25D366",
    color: "#fff",
    fontWeight: "bold",
    py: 1.5,
    fontSize: "16px",
    borderRadius: 2,
    "&:hover": { bgcolor: "#1ebe5d" }
  }}
>
  Join Our Channel
</Button>

        {/* EMAIL SUPPORT */}

        <Box
          sx={{
            mt: 3,
            textAlign: "center"
          }}
        >
          <Typography
            sx={{
              color: "#444",
              fontSize: "14px"
            }}
          >
           For any technical support, please write to us at:
          </Typography>

          <Typography
            component="a"
            href="mailto:info@shooinstars.com"
            sx={{
              display: "block",
              mt: 1,
              fontWeight: "bold",
              color: "#7b1fa2",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline"
              }
            }}
          >
            info@shooinstars.com
          </Typography>
        </Box>

      </Box>

    </Box>
  );
}

/* ================= SMALL REUSABLE UI ================= */

const SectionTitle = ({ text }) => (
  <Typography
    variant="h6"
    fontWeight="bold"
    sx={{ mt: 3, mb: 1 }}
  >
    {text}
  </Typography>
);

const Para = ({ children }) => (
  <Typography
    sx={{
      color: "#444",
      lineHeight: 1.8,
      mb: 1
    }}
  >
    {children}
  </Typography>
);

const Bullet = ({ text }) => (
  <Typography sx={{ ml: 2, mb: 0.7 }}>
    • {text}
  </Typography>
);

const DividerBlock = () => (
  <Divider sx={{ my: 3 }} />
);
